import React, { Component } from "react";
import Numbers from "../../../../services/numbers.service";
import OtpScreen from "../../../shared/otp-screen/otpScreen";
import SpinnerTimeLoader from "../../../shared/timeLoading";

export default class VerfiyMNP extends Component {
  state = {
    form: null,
    loading: true,
    sendOtpLoading: false,
  };

  last_otp_request = null;

  requestNewOtp = () => {
    this.setState({
      sendOtpLoading: true,
    });
    this.props.handleClearError()
    if (this.last_otp_request) {
      //console.log("no can do");
    } else {
      this.last_otp_request = setTimeout(() => {
        this.last_otp_request = null;
        this.setState({
          sendOtpLoading: false,
        });
      }, 5000);

      Numbers.requestMnpOtp(); //.then().catch();
    }
  };
  inputDigits = (event, limit) => {
    const re = /^[0-9\b]+$/;
    return (
      event.target.value === "" ||
      (event.target.value.length <= limit && re.test(event.target.value))
    );
  };

  render() {
    if (this.state.sendOtpLoading) {
      return <SpinnerTimeLoader />;
    }
    return (
      <OtpScreen
        onSubmit={this.props.submit}
        isFormValid={this.props.state.formValid}
        requestNewOtp={this.requestNewOtp}
        otpError={this.props.otpError}
        handleOtpForm={this.props.handleOtpForm}
        handleOtpError={this.props.handleOtpError}
        title="stm_otp_title"
        desc="stm_otp_desc"
        translationNeeded={true}
      />
    );
  }
}
